import classNames from 'classnames';
import { Container } from './Button.styles';
import { HudIcon, type IconType } from '../../../Icons/HudIcons';

export const BUTTON_SKINS = [
  'default',
  'brand',
  'positive',
  'destructive',
  'warning',
  'upsell',
] as const;

type ButtonProps = {
  size?: 'tiny' | 'small' | 'medium';
  skin?: (typeof BUTTON_SKINS)[number];
  prefixIcon?: IconType;
  suffixIcon?: IconType;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  disabled?: boolean;
  href?: string;
  target?: string;
  className?: string;
} & React.PropsWithChildren;

const Button: React.FC<ButtonProps> = ({
  size = 'small',
  skin = 'default',
  prefixIcon,
  suffixIcon,
  children,
  onClick,
  disabled,
  href,
  target,
  className: baseClassName,
  ...rest
}) => {
  const className = classNames(size, skin, baseClassName);
  if (href) {
    return (
      <Container
        as="a"
        className={className}
        href={disabled ? undefined : href}
        aria-disabled={disabled}
        onClick={disabled ? (e) => e.preventDefault() : onClick}
        tabIndex={disabled ? -1 : undefined}
        target={target}
        {...rest}
      >
        {prefixIcon && <HudIcon icon={prefixIcon} size="16px" />}
        {children}
        {suffixIcon && <HudIcon icon={suffixIcon} size="16px" />}
      </Container>
    );
  }
  return (
    <Container className={className} onClick={onClick} disabled={disabled} {...rest}>
      {prefixIcon && <HudIcon icon={prefixIcon} size="16px" />}
      {children}
      {suffixIcon && <HudIcon icon={suffixIcon} size="20px" className="suffixIcon" />}
    </Container>
  );
};

export default Button;
